"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/mutations/index.ts
var mutations_exports = {};
__export(mutations_exports, {
  cancelBooking: () => cancelBooking_default,
  cancelPaymentSession: () => cancelPaymentSession_default,
  checkinBooking: () => checkinBooking_default,
  confirmBooking: () => confirmBooking_default,
  confirmPayment: () => confirmPayment_default,
  createBooking: () => createBooking_default,
  createTranslationMemoryItem: () => createTranslationMemoryItem_default,
  declineBooking: () => declineBooking_default,
  deleteBooking: () => deleteBooking_default,
  linkAccount: () => linkAccount_default,
  makePayment: () => makePayment_default,
  recordPartnerUserLogin: () => recordPartnerUserLogin_default,
  submitTokenExToken: () => submitTokenExToken_default,
  updateCheckoutSession: () => updateCheckoutSession_default,
  updateConsumer: () => updateConsumer_default
});
module.exports = __toCommonJS(mutations_exports);

// src/apollo.ts
var import_client = require("@apollo/client");
var import_link_error = require("@apollo/link-error");
var import_deepmerge = __toESM(require("deepmerge"));
var import_isEqual = __toESM(require("lodash/isEqual"));
var import_react = require("react");
var import_session = require("supertokens-auth-react/recipe/session");
var import_client2 = require("@apollo/client");
var graphqlUrl = process.env.NEXT_PUBLIC_PRODUCTION_API_URL;
var checkProtected = () => {
  if (typeof window !== "undefined") {
    const { pathname } = window.location;
    return !pathname.startsWith("/auth") && !pathname.startsWith("/signup");
  }
};
var redirectLogin = () => {
  if (typeof window !== "undefined") {
    window.location.href = `/auth/login/?redirecturl=${window.location.pathname + window.location.search}`;
  }
};
var withTokenRefresh = new import_client.ApolloLink((operation, forward) => {
  if (checkProtected()) {
    return (0, import_client.fromPromise)(
      (0, import_session.attemptRefreshingSession)().then((success) => {
        if (!success) {
          redirectLogin();
        }
        return (0, import_client.toPromise)(forward(operation));
      })
    );
  }
  return forward(operation);
});
var httpLink = new import_client.HttpLink({
  uri: graphqlUrl,
  credentials: "include"
});
var httpLinkProxy = new import_client.HttpLink({
  uri: "/api/graphql",
  credentials: "include"
});
var errorLink = (0, import_link_error.onError)(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(
      ({ message, locations, path }) => console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  }
  if (networkError) {
    console.log(
      `[Network error]: ${networkError}. Backend is unreachable. Is it running?`,
      `[Graphql URL]: ${graphqlUrl}`
    );
  }
});

// src/mutations/checkinBooking.ts
var checkinBooking = import_client2.gql`
  mutation CheckinBooking($checkinBookingId: ID!) {
    checkinBooking(id: $checkinBookingId) {
      bookedFrom
      bookedTo
      consumer {
        id
      }
      createdAt
      id
      status
      updatedAt
    }
  }
`;
var checkinBooking_default = checkinBooking;

// src/mutations/confirmBooking.ts
var confirmBooking = import_client2.gql`
  mutation ConfirmBooking($confirmBookingId: ID!) {
    confirmBooking(id: $confirmBookingId) {
      bookedFrom
      bookedTo
      createdAt
      consumer {
        id
      }
      id
      experience {
        id
      }
      status
      updatedAt
    }
  }
`;
var confirmBooking_default = confirmBooking;

// src/mutations/createBooking.ts
var createBooking = import_client2.gql`
  mutation CreateBooking($bookingInput: BookingInput) {
    createBooking(bookingInput: $bookingInput) {
      bookedFrom
      bookedTo
      consumer {
        id
      }
      id
      experience {
        id
      }
      productID
      status
      updatedAt
      createdAt
      usedEntitlementsCount
    }
  }
`;
var createBooking_default = createBooking;

// src/mutations/declineBooking.ts
var declineBooking = import_client2.gql`
  mutation DeclineBooking($declineBookingId: ID!) {
    declineBooking(id: $declineBookingId) {
      bookedFrom
      bookedTo
      consumer {
        id
      }
      createdAt
      experience {
        id
      }
      id
      status
      updatedAt
    }
  }
`;
var declineBooking_default = declineBooking;

// src/mutations/deleteBooking.ts
var deleteBooking = import_client2.gql`
  mutation DeleteBooking($deleteBookingId: ID!) {
    deleteBooking(id: $deleteBookingId) {
      bookedTo
      bookedFrom
      consumer {
        id
      }
      createdAt
      status
      id
      experience {
        id
      }
      updatedAt
    }
  }
`;
var deleteBooking_default = deleteBooking;

// src/mutations/cancelBooking.ts
var cancelBooking = import_client2.gql`
  mutation cancelBooking($cancelBookingId: ID!) {
    cancelBooking(id: $cancelBookingId) {
      bookedFrom
      bookedTo
      consumer {
        id
      }
      createdAt
      experience {
        id
      }
      id
      status
      updatedAt
    }
  }
`;
var cancelBooking_default = cancelBooking;

// src/mutations/linkAccount.ts
var linkAccount = import_client2.gql`
  mutation LinkAccount($linkedAccountInput: LinkedAccountInput) {
    linkAccount(linkedAccountInput: $linkedAccountInput) {
      id
      externalID
      consumer {
        id
        fullName
        firstName
        lastName
        dateOfBirth
        emailAddress
        phone
        crmId
        linkedAccounts {
          id
        }
        createdAt
        updatedAt
      }
      sourceCode
      provider
      membershipID
      membershipType
      createdAt
      updatedAt
    }
  }
`;
var linkAccount_default = linkAccount;

// src/mutations/updateConsumer.ts
var updateConsumer = import_client2.gql`
  mutation UpdateConsumer($consumerInput: ConsumerInput) {
    updateConsumer(consumerInput: $consumerInput) {
      id
    }
  }
`;
var updateConsumer_default = updateConsumer;

// src/mutations/createTranslationMemoryItem.ts
var createTranslationMemoryItem = import_client2.gql`
  mutation CreateTranslationMemoryItem(
    $text: String!
    $originOutletId: String
    $originSection: String
    $isEnglishOnly: Boolean
  ) {
    createTranslationMemoryItem(
      text: $text
      originOutletId: $originOutletId
      originSection: $originSection
      isEnglishOnly: $isEnglishOnly
    ) {
      id
    }
  }
`;
var createTranslationMemoryItem_default = createTranslationMemoryItem;

// src/mutations/cancelPaymentSession.ts
var cancelPaymentSession = import_client2.gql`
  mutation CancelPaymentSession($paymentId: ID!) {
    cancelPaymentSession(paymentId: $paymentId) {
      paymentId
      paymentStatusResult
    }
  }
`;
var cancelPaymentSession_default = cancelPaymentSession;

// src/mutations/makePayment.ts
var makePayment = import_client2.gql`
  mutation MakePayment($makePaymentInput: MakePaymentInput!) {
    makePayment(makePaymentInput: $makePaymentInput) {
      paymentSessionId
      paymentServiceProvider
      url
      tokenExCvvConfig {
        tokenExId
        origin
        timestamp
        authenticationKey
        token
        cardType
      }
    }
  }
`;
var makePayment_default = makePayment;

// src/mutations/updateCheckoutSession.ts
var updateCheckoutSession = import_client2.gql`
  mutation UpdateCheckoutSession(
    $paymentSessionContextInput: PaymentSessionContextInput!
  ) {
    updateCheckoutSession(
      paymentSessionContextInput: $paymentSessionContextInput
    )
  }
`;
var updateCheckoutSession_default = updateCheckoutSession;

// src/mutations/submitTokenExToken.ts
var submitTokenExToken = import_client2.gql`
  mutation SubmitTokenExToken(
    $submitTokenExTokenInput: SubmitTokenExTokenInput!
  ) {
    submitTokenExToken(submitTokenExTokenInput: $submitTokenExTokenInput)
  }
`;
var submitTokenExToken_default = submitTokenExToken;

// src/mutations/confirmPayment.ts
var confirmPayment = import_client2.gql`
  mutation ConfirmPayment($input: ConfirmPaymentInput!) {
    confirmPayment(input: $input) {
      status
      paymentId
      redirectUrl
      paymentMethod
    }
  }
`;
var confirmPayment_default = confirmPayment;

// src/mutations/recordPartnerUserLogin.ts
var recordPartnerUserLogin = import_client2.gql`
  mutation RecordPartnerUserLogin {
    recordPartnerUserLogin {
      id
      lastLoginAt
    }
  }
`;
var recordPartnerUserLogin_default = recordPartnerUserLogin;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  cancelBooking,
  cancelPaymentSession,
  checkinBooking,
  confirmBooking,
  confirmPayment,
  createBooking,
  createTranslationMemoryItem,
  declineBooking,
  deleteBooking,
  linkAccount,
  makePayment,
  recordPartnerUserLogin,
  submitTokenExToken,
  updateCheckoutSession,
  updateConsumer
});
